<!-- <div class="m-subheader" appunwraptag="">
	<div class="d-flex align-items-center">
		<div class="mr-auto">
			<h3 class="m-subheader__title m-subheader__title--separator">
				ToT/ToA Dashboard
			</h3>
			<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
				<li class="m-nav__item m-nav__item--home">
					<a class="m-nav__link m-nav__link--icon">
						<i class="la la-briefcase"></i>
					</a>
				</li>
				<li class="m-nav__separator">
					-
				</li>
				<li class="m-nav__item">
					<span class="m-nav__link-text">
						Search & Apply
					</span>
				</li>
				<li class="m-nav__separator">
					-
				</li>
				<li class="m-nav__item">
					<span class="m-nav__link-text">
						Search Batches
					</span>
				</li>
			</ul>
		</div>
	</div>
</div>

<div class="m-content">
	<div class="m-portlet m-portlet--tab">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-text title-style">
					<label class="col-md-5 col-lg-5 col-sm-3">Search & Training Requests</label>
					<button class="btn btn-secondary pull-right" routerLink="../">
						Back
					</button>
					<button class="btn btn-secondary pull-right btn-alignment" routerLink="./../view-batches">
						View My Batches
					</button>
					<button class="btn btn-secondary pull-right btn-alignment" *ngIf="showPreferenceButton" data-target="#preferences_modal" data-toggle="modal">
						Add Training Requests
					</button>
				</div>
			</div>
		</div>

		<div class="m-portlet__body">
			<ul class="nav nav-pills" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" #batchDetails data-toggle="tab" href="#m_tab_search_batches" (click)="hideButton()">
						Search Batches
					</a>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link" #preferences data-toggle="tab" href="#m_tab_preferences" (click)="setData()">
						Training Requests
					</a>
				</li>
				<hr>
			</ul> -->

<div class="m-form">
	<form class="m-form m-form--fit m-form--label-align-right" [formGroup]="searchBatchesForm">
		<div class="m-portlet__body">
			<div class="form-group m-form__group row">
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label>
						State:
					</label>
					<select class="form-control m-input m-input--square" formControlName="state" name="option"
						(change)="_applicantDataService.getDistricts();getSelectedData()">
						<option value="" selected>Select State</option>
						<option *ngFor="let state of _applicantDataService.states" [ngValue]="state">{{state.name}}
						</option>
					</select>
					<app-form-control-messages [control]="searchBatchesForm.get('state')" [name]="'State'">
					</app-form-control-messages>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label class="">
						District:
					</label>
					<select class="form-control m-input m-input--square" formControlName="district"
						(change)="_applicantDataService.getSubDistricts();getSelectedData()" name="option">
						<option value="" selected>Select District</option>
						<option *ngFor="let district of _applicantDataService.districts" [ngValue]="district">
							{{district.name}}</option>
					</select>
					<app-form-control-messages [control]="searchBatchesForm.get('district')" [name]="'District'">
					</app-form-control-messages>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label class="">
						Sub-District:
					</label>
					<select class="form-control m-input m-input--square" formControlName="subDistrict" name="option">
						<option value="" selected>Select Sub-District</option>
						<option *ngFor="let subDistrict of _applicantDataService.subDistricts" [ngValue]="subDistrict">
							{{subDistrict.name}}</option>
					</select>
					<app-form-control-messages [control]="searchBatchesForm.get('subDistrict')" [name]="'Sub-District'">
					</app-form-control-messages>
				</div>
			</div>
			<div class="form-group m-form__group row">
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label>
						Sector:
					</label>
					<select class="form-control m-input m-input--square" name="option" formControlName="sector"
						(change)="getSelectedData(); _applicantDataService.getJobRoles();">
						<option value="" selected>Select Sector</option>
						<option *ngFor="let sector of _applicantDataService.sectors" [ngValue]="sector">
							{{sector.sector}}</option>
					</select>
					<app-form-control-messages [control]="searchBatchesForm.get('sector')" [name]="'Sector'">
					</app-form-control-messages>
				</div>
				<!-- <div class="col-lg-4 col-md-4 col-sm-4">
									<label class="">
										Sub-Sector:
									</label>
									<select class="form-control m-input m-input--square" formControlName="subSector" (change)="_applicantDataService.getJobRoles();getSelectedData()"
									 name="option">
										<option value="" selected>Select Sub-Sector</option>
										<option *ngFor="let subSector of _applicantDataService.subSectors" [ngValue]="subSector">{{subSector.subSectorName}}</option>
									</select>
									<app-form-control-messages [control]="searchBatchesForm.get('subSector')" [name]="'Sub-Sector'"></app-form-control-messages>
								</div> -->
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label class="">
						Job Role:
					</label>
					<select class="form-control m-input m-input--square" formControlName="jobRole" name="option">
						<option value="" selected>Select Job Role</option>
						<option *ngFor="let jobRole of _applicantDataService.jobRoles" [ngValue]="jobRole">
							{{jobRole.jobRole}} ({{jobRole.qpCode}}) - v{{jobRole.version}}</option>
					</select>
					<app-form-control-messages [control]="searchBatchesForm.get('jobRole')" [name]="'Job Role'">
					</app-form-control-messages>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label>
						Batch Type:
					</label>
					<select class="form-control m-input m-input--square" title="Select Batch Type"
						formControlName="type" (change)="getSelectedData()">
						<option value="" selected>Select Batch Type</option>
						<option *ngFor="let batchType of _applicantDataService.batchTypes" [ngValue]="batchType">
							{{batchType}}</option>
					</select>
				</div>
			</div>
			<div class="form-group m-form__group row">
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label class="">
						Batch Start Date:
					</label>
					<div class="col-lg-12 col-md-12 col-sm-12">
						<app-date-picker [model]="startDateObject" (dateChanged)="selectedStartDate($event)">
						</app-date-picker>
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<label class="">
						Batch End Date:
					</label>
					<div class="col-lg-12 col-md-12 col-sm-12">
						<app-date-picker [model]="endDateObject" (dateChanged)="selectedEndDate($event)">
						</app-date-picker>
					</div>
				</div>
			</div>
			<div class="form-group m-form__group row">
				<div class="col-lg-4 col-md-4 col-sm-4"></div>
				<div class="col-lg-8 col-md-8 col-sm-8">
					<label>
						Keyword Search:
					</label>
					<app-search (searchValue)="setSearchText($event)" placeholder="Search for Training Centre Name"
						class="width-100 "></app-search>
				</div>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
			<div class="m-form__actions">
				<div class="pull-right">
					<button type="submit" class="btn btn-primary" (click)="search()"
						[disabled]="isSearchDisabled">
						<!-- [disabled]="!searchBatchesForm.get('state').valid || !searchBatchesForm.get('sector').valid" -->
						Search
					</button>
					<button type="submit" class="btn btn-secondary" (click)="addJobRole()"
						[disabled]="!searchBatchesForm.valid">
						Add Job Role & Location to Training Requests
					</button>
					<button type="reset" class="btn btn-secondary" routerLink="../">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</form>
	<hr>
	<app-search-result-for-applicant (sendData)="showViewlinkRequestModel($event)" [searchedData]="searchResult">
	</app-search-result-for-applicant>
	<div *ngIf="searchResult && searchResult.length > 0">
		<app-pagination [count]=length (pageNumber)="setPageNumber($event)"
			(recordsPerPage)="setRecordsPerPage($event)"></app-pagination>
	</div>
</div>

<div class="modal fade align-modal show" id="linkTrainingRequest" tabindex="-1" role="dialog"
	aria-labelledby="exampleModalLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content set-width">
			<div class="modal-header">
				<h1 class="modal-title">
					<b>View and Link Training Request(s)</b>
				</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span id="closeModal" data-dismiss="modal" aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="row">
					<span class="col-4">
						<label><b>Batch ID:</b></label>
						<span>{{appliedBatch?.batchId}}</span>
					</span>
					<span class="col-8">
						<label><b>Batch Name:</b></label>
						<span>{{appliedBatch?.batchName}}</span>
					</span>
				</div>
				<div class="row">
					<span class="col-4">
						<label><b>Batch Type:</b></label>
						<span>{{appliedBatch?.type}}</span>
					</span>
					<span class="col-4">
						<label><b>Batch Date:</b></label>
						<span>{{appliedBatch?.batchStartDate | date: 'dd/MM/yyyy'}} to
							{{appliedBatch?.batchEndDate | date: 'dd/MM/yyyy'}}</span>
					</span>
					<span class="col-4">
						<label><b>Batch Fee:</b></label>
						<span>{{appliedBatch?.batchFee?.totalFees}}</span>
					</span>
				</div>
				<hr>
				<div class="row">
					<span type="text" class="btn btn-link placeholder-color">
						Selected Request
					</span>
					<button type="button" class="btn btn-danger" (click)="resetAllCandidates()" style="margin:0 10px;">
						De-Select All
					</button>
					<button type="button" class="btn btn-primary" (click)="linkTrainingRequest()">
						Link Request(s)
					</button>
				</div>
				<hr>
				<div class="col-12">
					<table class="table">
						<thead>
							<td>
								<label class="m-checkbox m-checkbox--solid m-checkbox--state-success">
									<input type="checkbox" [(ngModel)]="selectStatus" name="Checkbox"
										(click)="selectAll()">
									<span></span>
								</label>
							</td>
							<td>Job Role Name(QP Code)</td>
							<td>Sector</td>
							<td>State</td>
							<td>District</td>
							<td>Requested On</td>
						</thead>
						<tbody *ngFor="let request of trainingRequestLists; let i = index">
							<tr>
								<td>
									<label class="m-checkbox m-checkbox--solid m-checkbox--state-success">
										<input type="checkbox" [(ngModel)]="request.isSelected" name="Check"
											(click)=selectOne(i)>
										<span></span>
									</label>
								</td>
								<td>{{request?.jobRole?.jobName}} ({{request?.jobRole?.qpCode}})</td>
								<td>{{request?.sector?.sector}}</td>
								<td>{{request?.state?.name}}</td>
								<td>{{request?.district?.name}}</td>
								<td>{{request?.requestedOn | date: 'dd/MM/yyy'}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <app-pagination [count]="count" (pageNumber)="changePageNumber($event)"
						[defaultRecordsPerPage]="perPage" (recordsPerPage)="changeRecordsPerPage($event)">
					</app-pagination> -->
				<hr>
				<div class="pull-right">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
					<button class="btn btn-primary" (click)="linkTrainingRequest()">Link Request(s)</button>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- <div class="tab-pane" id="m_tab_preferences" role="tabpanel">
		<app-applicant-preferences #prefrences></app-applicant-preferences>
	</div> -->

<!-- Modal -->
<!-- <div class="modal fade" id="preferences_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    Add Training Requests
                </h5>
                <button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
            </div>
            <div class="modal-body">
                <div class="m-section">
                    <div class="m-section__content">
                        <form class="m-form" [formGroup]="searchBatchesForm">
                            <label class="">Preferred Job Role:</label>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-md-4 col-sm-4 col-form-label">
									Select Sector
									<span style="color: red">*</span>:
								</label>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
                                    </div>
                                    <select class="form-control m-input m-input--square" name="option" formControlName="sector" (change)="_applicantDataService.getJobRoles()">
										<option value="" selected>Select Sector</option>
										<option *ngFor="let sector of _applicantDataService.sectors" [ngValue]="sector">
											{{sector.sector}}</option>
									</select>
                                </div>
                            </div> -->
<!-- <div class="form-group m-form__group row">
								<label class="col-lg-4 col-md-4 col-sm-4 col-form-label">
									Select Sub-Sector
									<span style="color: red">*</span>:
								</label>
								<div class="col-lg-8 col-md-8 col-sm-8">
									<div class="form-select-side">
										<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
											</g>
										</svg>
									</div>
									<select class="form-control m-input m-input--square" formControlName="subSector" (change)="_applicantDataService.getJobRoles()"
									 name="option">
										<option value="" selected>Select Sub-Sector</option>
										<option *ngFor="let subSector of _applicantDataService.subSectors" [ngValue]="subSector">{{subSector.subSectorName}}</option>
									</select>
								</div>
							</div> -->
<!-- <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-md-4 col-sm-4 col-form-label">
									Select Job Role
									<span style="color: red">*</span>:
								</label>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
                                    </div>
                                    <select class="form-control m-input m-input--square" formControlName="jobRole" name="option">
										<option value="" selected>Select Job Role</option>
										<option *ngFor="let jobRole of _applicantDataService.jobRoles"
											[ngValue]="jobRole">{{jobRole.jobRole}} ({{jobRole.qpCode}}) -
											v{{jobRole.version}}</option>
									</select>
                                </div>
                            </div>
                            <hr>
                            <label class="form-group m-form__group">Preferred Location:</label>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-md-4 col-sm-4 col-form-label">
									State
									<span style="color: red">*</span>:
								</label>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
                                    </div>
                                    <select class="form-control m-input m-input--square" formControlName="state" name="option" (change)="_applicantDataService.getDistricts()">
										<option value="" selected>Select State</option>
										<option *ngFor="let state of _applicantDataService.states" [ngValue]="state">
											{{state.name}}</option>
									</select>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-md-4 col-sm-4 col-form-label">
									District: -->
<!-- <span style="color: red">*</span>: -->
<!-- </label>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
                                    </div>
                                    <select class="form-control m-input m-input--square" formControlName="district" (change)="_applicantDataService.getSubDistricts()" name="option" placeholder="Select District">
										<option value="" selected>Select District</option>
										<option *ngFor="let district of _applicantDataService.districts"
											[ngValue]="district">{{district.name}}</option>
									</select>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-md-4 col-sm-4 col-form-label">
									Sub-District: -->
<!-- <span style="color: red">*</span>: -->
<!-- </label>
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <div class="form-select-side">
                                        <svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
                                    </div>
                                    <select class="form-control m-input m-input--square" formControlName="subDistrict" name="option" placeholder="Select Sub-District">
										<option value="" selected>Select Sub-District</option>
										<option *ngFor="let subDistrict of _applicantDataService.subDistricts"
											[ngValue]="subDistrict">{{subDistrict.name}}</option>
									</select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="addJobRole();setData()">
					Add Training Request
				</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="resetFormData()">
					Close
				</button>
            </div>
        </div>
    </div>
</div> -->
